import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { useAuth } from "@/auth";
import { ShieldCheck } from "lucide-react";

export default function AuditLog() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 100 } })
      .then((r) => setLogs(r.data))
      .catch((e) => setErr(formatApiError(e)));
  }, []);

  if (user?.role !== "OWNER") {
    return (
      <div className="p-10 text-sm text-[#52525B]">
        <div className="max-w-md bg-white border border-[#E5E5E2] rounded-md p-6">
          <ShieldCheck className="w-6 h-6 text-[#0F4C3A] mb-2" />
          <div className="font-display text-lg font-bold tracking-tight">Restricted</div>
          <div className="text-sm text-[#52525B] mt-1">
            Only the clinic owner can view the audit trail.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-[1200px] mx-auto">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-[#E27B58] font-semibold mb-1">Compliance</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Audit Log</h1>
        <p className="text-sm text-[#52525B] mt-1">DPDP-aligned event trail · immutable</p>
      </div>
      {err && <div className="text-sm text-[#991B1B]">{err}</div>}
      <div className="bg-white border border-[#E5E5E2] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-[#52525B] bg-[#FDFDFB]">
              <th className="p-3 border-b border-[#E5E5E2]">Time</th>
              <th className="p-3 border-b border-[#E5E5E2]">Action</th>
              <th className="p-3 border-b border-[#E5E5E2]">Entity</th>
              <th className="p-3 border-b border-[#E5E5E2]">Entity ID</th>
              <th className="p-3 border-b border-[#E5E5E2]">Actor</th>
              <th className="p-3 border-b border-[#E5E5E2]">Meta</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-[#52525B]">No entries.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-[#FDFDFB]" data-testid={`audit-row-${l.id}`}>
                <td className="p-3 border-b border-[#E5E5E2] font-mono-num text-[#52525B]">{new Date(l.created_at).toLocaleString("en-IN")}</td>
                <td className="p-3 border-b border-[#E5E5E2] font-medium capitalize">{l.action}</td>
                <td className="p-3 border-b border-[#E5E5E2] capitalize">{l.entity}</td>
                <td className="p-3 border-b border-[#E5E5E2] font-mono-num text-xs text-[#52525B]">{l.entity_id.slice(0, 8)}…</td>
                <td className="p-3 border-b border-[#E5E5E2] font-mono-num text-xs text-[#52525B]">{l.actor_id.slice(0, 8)}…</td>
                <td className="p-3 border-b border-[#E5E5E2] font-mono-num text-xs text-[#52525B]">{Object.keys(l.meta||{}).length ? JSON.stringify(l.meta) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
